import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import {
  DashboardOutlined,
  MedicineBoxOutlined,
  UserOutlined,
  SwapOutlined,
  TeamOutlined,
  EnvironmentOutlined,
  HistoryOutlined,
} from '@ant-design/icons';
import GcPagina from '../components/Layout/GcPagina';
import { FctTarjeta } from '../fct/react';
import DashboardTab from '../components/Reconciliacion/DashboardTab';
import FarmaciasTab from '../components/Reconciliacion/FarmaciasTab';
import FarmaceuticosTab from '../components/Reconciliacion/FarmaceuticosTab';
import TransmisionesTab from '../components/Reconciliacion/TransmisionesTab';
import EmpleadosTab from '../components/Reconciliacion/EmpleadosTab';
import TrasladosTab from '../components/Reconciliacion/TrasladosTab';
import HistoricoTab from '../components/Reconciliacion/HistoricoTab';
import { ESTADO_CICLO_COMPLETADO, getCiclos, type ReconciliacionCiclo } from '../api/reconciliacionApi';

const ReconciliacionPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [selectedRecIds, setSelectedRecIds] = useState<number[]>([]);
  const [ciclos, setCiclos] = useState<ReconciliacionCiclo[]>([]);

  useEffect(() => {
    const init = async () => {
      try {
        const data = await getCiclos();
        setCiclos(data);
        // El ciclo actual es el último completado: uno en curso o con error no tiene detalle (#151, §4.6).
        const actual = data.find(c => c.estado === ESTADO_CICLO_COMPLETADO);
        if (actual) {
          setSelectedRecIds([actual.id]);
        }
      } catch { /* silently fail */ }
    };
    init();
  }, []);

  const tabItems = [
    {
      key: 'dashboard',
      label: <span><DashboardOutlined /> Dashboard</span>,
      children: <DashboardTab onTabChange={setActiveTab} />,
    },
    {
      key: 'farmacias',
      label: <span><MedicineBoxOutlined /> Farmacias</span>,
      children: <FarmaciasTab selectedRecIds={selectedRecIds} />,
    },
    {
      key: 'farmaceuticos',
      label: <span><UserOutlined /> Farmacéuticos</span>,
      children: <FarmaceuticosTab selectedRecIds={selectedRecIds} />,
    },
    {
      key: 'transmisiones',
      label: <span><SwapOutlined /> Transmisiones</span>,
      children: <TransmisionesTab selectedRecIds={selectedRecIds} />,
    },
    {
      key: 'empleados',
      label: <span><TeamOutlined /> Empleados</span>,
      children: <EmpleadosTab selectedRecIds={selectedRecIds} />,
    },
    {
      key: 'traslados',
      label: <span><EnvironmentOutlined /> Traslados</span>,
      children: <TrasladosTab selectedRecIds={selectedRecIds} />,
    },
    {
      key: 'historico',
      label: <span><HistoryOutlined /> Histórico</span>,
      children: <HistoricoTab ciclos={ciclos} selectedRecIds={selectedRecIds} onSelectionChange={setSelectedRecIds} onCiclosReload={setCiclos} />,
    },
  ];

  return (
    <GcPagina
      seccion="Conciliación"
      titulo="Conciliación con datos oficiales"
      contexto="Conciliación CU2-Gescom"
      densidad="compacta"
    >
      <FctTarjeta>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabItems}
          size="large"
        />
      </FctTarjeta>
    </GcPagina>
  );
};

export default ReconciliacionPage;
